module.exports = __webpack_public_path__ + "img/refresh.699f0d67.svg";